const stickyAnnouncementUntilHeaderOut = () => {
  const header = document.querySelector("store-header[data-is-sticky='true']");
  const announcementSection = document.querySelector(".cc-announcement");
  const headerSection = header?.closest(".cc-header");

  if (!header || !announcementSection || !headerSection) {
    return;
  }

  let headerHasBeenOutSinceTop =
    document.documentElement.scrollTop > 200 || header.classList.contains("is-out");

  const updateAnnouncementHeight = () => {
    document.documentElement.style.setProperty(
      "--tpg-announcement-height",
      `${announcementSection.offsetHeight || 0}px`
    );
  };

  const syncState = () => {
    const scrollTop = document.documentElement.scrollTop;

    if (scrollTop <= 1) {
      headerHasBeenOutSinceTop = false;
    }

    if (header.classList.contains("is-out")) {
      headerHasBeenOutSinceTop = true;
    }

    const shouldStick = !headerHasBeenOutSinceTop && !header.classList.contains("is-out");

    announcementSection.classList.toggle(
      "tpg-stick-until-header-out",
      shouldStick
    );
    document.body.classList.toggle("tpg-announcement-sticky-active", shouldStick);

    if (shouldStick) {
      updateAnnouncementHeight();
    }
  };

  updateAnnouncementHeight();
  syncState();

  const classObserver = new MutationObserver(syncState);
  classObserver.observe(header, { attributes: true, attributeFilter: ["class"] });
  window.addEventListener("scroll", syncState, { passive: true });

  if ("ResizeObserver" in window) {
    const resizeObserver = new ResizeObserver(() => {
      updateAnnouncementHeight();
      syncState();
    });
    resizeObserver.observe(announcementSection);
  } else {
    window.addEventListener("resize", () => {
      updateAnnouncementHeight();
      syncState();
    });
  }
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", stickyAnnouncementUntilHeaderOut);
} else {
  stickyAnnouncementUntilHeaderOut();
}
